<template>
  <core-FormModal
    v-model="show"
    :submit="submitReport"
    class="mt-3"
    size="lg"
    :textSubmit="model.Agendar ? 'Agendar Relatório' : 'Solicitar Relatório'"
    :scrollable="scrollable"
  >
    <template v-slot:title>
      Solicitação Relatório
    </template>

    <template v-slot:body>
      <b-form-row class="align-items-start">
        <!-- Tipo Arquivo -->
        <b-col md="4">
          <b-form-group label="Tipo Arquivo">
            <input-select
              v-model="model.TipoArquivo"
              :options="TipoArquivoRelatorio"
              single
            />
          </b-form-group>
        </b-col>
        
        <b-col md="4" class="pt-4">
          <label class="switcher">
            <input
              type="checkbox"
              v-model="model.IncluirFinalidadeTransf"
              class="switcher-input"
            />
            <span class="switcher-indicator">
              <span class="switcher-yes">
                <span class="ion ion-md-checkmark"></span>
              </span>
              <span class="switcher-no">
                <span class="ion ion-md-close"></span>
              </span>
            </span>
            <span class="switcher-label">
              <strong>Incluir natureza da movimentação</strong>
            </span>
          </label>
        </b-col>

        <!-- Enviar Email -->
        <b-col md="4" class="pt-4">
          <label class="switcher">
            <input
              type="checkbox"
              v-model="model.EnviarEmail"
              class="switcher-input"
            />
            <span class="switcher-indicator">
              <span class="switcher-yes">
                <span class="ion ion-md-checkmark"></span>
              </span>
              <span class="switcher-no">
                <span class="ion ion-md-close"></span>
              </span>
            </span>
            <span class="switcher-label">
              <strong>Permitir notificação via email</strong>
            </span>
          </label>
        </b-col>
        <b-col
          md="4"
          class="pt-4"
          v-if="agendamentoOption && model.TipoArquivo"
        >
          <label class="switcher">
            <input
              type="checkbox"
              v-model="model.Agendar"
              class="switcher-input"
            />
            <span class="switcher-indicator">
              <span class="switcher-yes">
                <span class="ion ion-md-checkmark"></span>
              </span>
              <span class="switcher-no">
                <span class="ion ion-md-close"></span>
              </span>
            </span>
            <span class="switcher-label">
              <strong>Agendar execução recorrente</strong>
            </span>
          </label>
        </b-col>
      </b-form-row>
      <b-form-row
        v-if="agendamentoOption && model.Agendar"
        class="mt-2"
      >
        <b-col md="4">
          <b-form-group label="Frequência">
            <input-select
              v-model="model.Frequencia"
              :options="frequenciaOptions"
              single
            />
          </b-form-group>
        </b-col>

        <b-col md="4" v-if="model.Frequencia === 2">
          <b-form-group label="Dia da Semana">
            <input-select
              v-model="model.DiaSemana"
              :options="DiaSemana"
              single
            />
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row
        v-if="agendamentoOption && model.Agendar"
        class="mt-2"
      >
        <b-col md="12">
          <small>
            Ao confirmar, o relatório será gerado imediatamente. <br>
            O agendamento será salvo para que novas execuções ocorram automaticamente na frequência escolhida.
          </small>
        </b-col>
      </b-form-row>
    </template>
  </core-FormModal>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      model: {
        EnviarEmail: false,
        Agendar: false,
        Frequencia: 1,
        IncluirFinalidadeTransf: false,
      },
      title: "ExportarRelatorio",
      DiaSemana: this.$api.Arrays.DiaSemana,
    };
  },

  props: {
    submit: Function,
    TipoArquivoRelatorio: Array,
    frequenciaAgendamentoAceita: {
      type: Array,
      default: null,
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
    agendamentoOption: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    frequenciaOptions() {
      return (
        this.frequenciaAgendamentoAceita || this.$api.Arrays.FrequenciaAgendamento
      );
    },
  },

  methods: {
    openModal() {
      this.show = true;
    },

    close() {
      this.show = false;
      this.model = {
        EnviarEmail: false,
        Agendar: false,
        Frequencia: 1,
      };
    },

    submitReport() {
      if (this.model.Agendar) {
        if (
          this.model.Frequencia === 2 &&
          this.model.DiaSemana == null
        ) {
          return this.$api.UI.ShowError(
            "Erro",
            "Informe o dia da semana do agendamento."
          );
        }

        this.model.Agendamento = {
          Frequencia: this.model.Frequencia,
          DiaSemana: this.model.DiaSemana,
        };
      }

      this.submit(this.model, this.close);
    },
  },
};
</script>

<style scoped>
.pt-4 {
  padding-top: 32px;
}
</style>
